import { Interpolation, Theme, css } from '@emotion/react'

export const wrapper = css`
  display: flex;
  gap: 12px;
  margin-top: 46px;

  & > :nth-child(2) {
    margin-left: auto;
  }
`

export const backButton: Interpolation<Theme> = (theme) => css`
  height: 38px;
  padding: 0 18px 0 12px;
  color: ${theme.colors.gray};
  border-color: ${theme.colors.backgroundSix};
  gap: 5px;

  &:hover {
    color: ${theme.colors.gray};
    border-color: ${theme.colors.backgroundSix};
  }
`

export const addContentButton = css`
  height: 38px;
  padding: 0 12px 0 18px;
  gap: 5px;
`

export const exportButton = css`
  height: 38px;
  padding: 0 18px;
`

export const arrowIcon = css`
  width: 20px !important;
  height: 20px !important;
  rotate: -90deg;
`

export const plusIcon = css`
  width: 20px !important;
  height: 20px !important;
`
